import GenericDB from './generic-db';

export default class RealTimeNotificationsDB extends GenericDB {
  static context = {
    OFFLINE_MODE: 'offlineSyncing',
    PACKAGES: 'packageInstallation',
    INTEGRATIONS: 'integration',
    INTEGRATION_REFERENCES: 'integrationReferences',
    CLIENTS: 'clients',
  };

  constructor() {
    super('realTimeNotifications');
  }
}
